export enum StatusEleicao{   
        CRIADA = 0,
        EM_ANDAMENTO = 1,
        APURADA = 2,
        ENCERRADA = 3,
        PARADA = 4,
        CANCELADA = 5,
        PRORROGADA = 6,
        ZERESIMA = 7,
        EM_CANDIDATURA = 8,
        EM_APROVACOES = 9,
        AGUARDANDO_APROCACOES = 10,
}

